<div class="swag-migration-wizard swag-migration-wizard-page-credentials">
    {% block swag_migration_wizard_page_credentials_content %}
        <div class="swag-migration-wizard__content">
            {% block swag_migration_wizard_page_credentials_credentials %}
                <div class="swag-migration-wizard__form">
                    {% block swag_migration_wizard_page_credentials_local_db_host_port_group %}
                        <sw-container
                            columns="1fr 80px"
                            gap="16px"
                        >
                            {% block swag_migration_wizard_page_credentials_local_dbhost_field %}
                                <mt-text-field
                                    v-model:model-value="inputCredentials.dbHost"
                                    v-autofocus
                                    name="sw-field--dbHost"
                                    :label="$tc('swag-migration.wizard.pages.credentials.shopware55.local.dbHostLabel')"
                                    :placeholder="$tc('swag-migration.wizard.pages.credentials.shopware55.local.dbHostPlaceholder')"
                                />
                            {% endblock %}

                            {% block swag_migration_wizard_page_credentials_local_dbport_field %}
                                <mt-text-field
                                    v-model:model-value="inputCredentials.dbPort"
                                    name="sw-field--dbPort"
                                    :label="$tc('swag-migration.wizard.pages.credentials.shopware55.local.dbPortLabel')"
                                />
                            {% endblock %}
                        </sw-container>
                    {% endblock %}

                    {% block swag_migration_wizard_page_credentials_local_dbuser_field %}
                        <mt-text-field
                            v-model:model-value="inputCredentials.dbUser"
                            name="sw-field--dbUser"
                            :label="$tc('swag-migration.wizard.pages.credentials.shopware55.local.dbUserLabel')"
                            :placeholder="$tc('swag-migration.wizard.pages.credentials.shopware55.local.dbUserPlaceholder')"
                        />
                    {% endblock %}

                    {% block swag_migration_wizard_page_credentials_local_dbpassword_field %}
                        <mt-password-field
                            v-model:model-value="inputCredentials.dbPassword"
                            name="sw-field--dbPassword"
                            :label="$tc('swag-migration.wizard.pages.credentials.shopware55.local.dbPasswordLabel')"
                            :placeholder="$tc('swag-migration.wizard.pages.credentials.shopware55.local.dbPasswordPlaceholder')"
                        />
                    {% endblock %}

                    {% block swag_migration_wizard_page_credentials_local_dbname_field %}
                        <mt-text-field
                            v-model:model-value="inputCredentials.dbName"
                            name="sw-field--dbName"
                            :label="$tc('swag-migration.wizard.pages.credentials.shopware55.local.dbNameLabel')"
                            :placeholder="$tc('swag-migration.wizard.pages.credentials.shopware55.local.dbNamePlaceholder')"
                        />
                    {% endblock %}

                    {% block swag_migration_wizard_page_credentials_local_installationroot_field %}
                        <mt-text-field
                            v-model:model-value="inputCredentials.installationRoot"
                            name="sw-field--installationRoot"
                            :label="$tc('swag-migration.wizard.pages.credentials.shopware55.local.installationRoot')"
                            :placeholder="$tc('swag-migration.wizard.pages.credentials.shopware55.local.installationRootPlaceholder')"
                        />
                    {% endblock %}
                </div>
            {% endblock %}
        </div>
    {% endblock %}
</div>
